<script setup lang="ts">
import { RouterLink } from 'vue-router';
//import RtlLogo from '@/assets/images/logos/Rtllogo.svg';
import RtlLogo from '@/assets/images/logos/logo.svg';
</script>
<template>
    <div class="logo">
        <RouterLink to="/">
            <img :src="RtlLogo" alt="home" />
        </RouterLink>
    </div>
</template>
